export type StopEquipment = {
    id: number
    stopId: number
    equipmentTypeId: number
    quantityIn: number
    quantityOut: number | null
    equipmentShortReasonId: number | null
    shortComment: string | null
}

export type EquipmentType = {
    id: number
    description: string
    isShortReasonRequired: boolean
    isDeliveredInEditable: boolean
}

export enum PalletsRegular {
    Id = 4
}